import { loadUserSettings } from 'common/siteApi'
import { useState, useEffect, useCallback } from 'react'

import { getCollection } from 'utils/swrFirestore/core'
import { uniqBy } from 'lodash'
import { getUsersById } from 'utils/hooks'
import { getDocument } from '@nandorojo/swr-firestore'
import { get } from 'lodash'

export const usePaginatedUsersFromStaticUids = (uids, perPage = 10) => {
  const [page, setPage] = useState(1)
  const [loadedUsers, setLoadedUsers] = useState([])

  const maxPages = uids ? Math.ceil(uids.length / perPage) : 0
  if (perPage > 10) {
    console.warn('Firestore does not support perPage larger than 10!')
    perPage = 10
  }

  // So, this populate-10-at-a-time *works*, but may be unnecessary as apparently firestore pipelines requests so
  // Promise.all waiting on many individual gets may not be a performance issue at all in practice
  useEffect(() => {
    if (!uids) return
    const pageUids = uids.slice((page - 1) * perPage, page * perPage)
    if (pageUids.length === 0) return

    // Seems like *should* work, but doesn't, so working around w/ direct user gets
    // const getUsers = getCollection(
    //   'users',
    //   { where: [fuego.firestore.FieldPath.documentId(), 'in', pageUids] },
    //   { parseDates: ['meta.lastReviewedAt', 'meta.deletedAt'] },
    // )
    const getUsers = getUsersById(pageUids)
    getUsers.then((newUsers) => {
      setLoadedUsers(uniqBy([...loadedUsers, ...newUsers], (user) => user.id))
    })
  }, [page, perPage])

  const loadNextPage = useCallback(() => setPage(page + 1), [page])

  return {
    loadedUsers,
    loadNextPage,
    hasNextPage: page < maxPages,
  }
}

export const useNumUsersBlockedBy = (uid) => {
  const [num, setNum] = useState(0)

  useEffect(() => {
    if (!uid) return
    const getNum = async () => {
      const meta = await getDocument(`users/${uid}/extraUserData/blockings`)
      setNum(meta.numBlocking || 0)
    }
    getNum()
  }, [uid])

  return num
}

export const useUserSettingsData = (uid) => {
  const [data, setData] = useState(null)

  useEffect(() => {
    if (!uid) return
    loadUserSettings(uid).then(setData)
  }, [uid])

  return data
}

// Local state for optimistic updates + not requiring listen: true on doesFollow
export const useLocallyTrackedFollowing = (doesFollow) => {
  const [showAsFollowing, setShowAsFollowing] = useState(
    typeof doesFollow === 'undefined' ? undefined : !!doesFollow,
  )

  useEffect(() => {
    if (typeof doesFollow !== 'undefined') setShowAsFollowing(!!doesFollow)
  }, [doesFollow])

  return [showAsFollowing, setShowAsFollowing]
}
